export default class ScrollTo {

    static init() {
        Livewire.on('scrollto:immodvisor-widget', (alternativeUrl) => {
            const immodvisorWidget = document.querySelector('.immodvisor-widget-component');
            if (document.body.contains(immodvisorWidget)) {
                window.scroll({
                    behavior: 'smooth',
                    left: 0,
                    top: immodvisorWidget.offsetTop
                });
            } else {
                Object.assign(document.createElement('a'), {
                    target: '_blank',
                    href: alternativeUrl
                }).click();
            }
        });

        Livewire.on('scrollto:estimate_form', () => {
            let element = document.querySelector('.estimate-form-component');
            window.scroll({
                behavior: 'smooth',
                left: 0,
                top: element.offsetTop - 200
            });
        });

        Livewire.on('scrollto:contact_form', () => {
            let element = document.querySelector('.contact-form-component');
            window.scroll({
                behavior: 'smooth',
                left: 0,
                top: element.offsetTop - 200
            });
        });

        Livewire.on('scrollto:advertisement_contact_form', () => {
            let element = document.querySelector('.advertisement-contact-form-component');
            window.scroll({
                behavior: 'smooth',
                left: 0,
                top: element.offsetTop - 200
            });
        });

        Livewire.on('scrollto:quote_form', () => {
            let element = document.querySelector('.quote-form-component');
            window.scroll({
                behavior: 'smooth',
                left: 0,
                top: element.offsetTop - 200
            });
        });
    }

}
